export const HEADER_PATH = "HEADER_PATH";
export const INITIAL_STATE = "INITIAL_STATE";
